import React from 'react'
import styled, { css } from 'styled-components'

import { mediaMinTablet } from '../theme'

import { useControls } from './hooks/use-controls'

import type { EmblaCarouselType } from 'embla-carousel'

type Props = {
  api: EmblaCarouselType
}

export const SliderControls: React.FC<Props> = ({ api }) => {
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useControls(api)

  return (
    <Root>
      <Indicators>
        {scrollSnaps.map((_, index: number) => (
          <IndicatorSecondary
            key={index}
            onClick={() => onDotButtonClick(index)}
            aria-checked={index === selectedIndex}
          />
        ))}
      </Indicators>
    </Root>
  )
}

const Root = styled.div`
  display: grid;

  justify-self: center;
`

const Indicators = styled.div`
  display: grid;
  grid-auto-flow: column;
  place-content: center;
  align-items: center;

  gap: 6px;

  ${mediaMinTablet(css`
    margin-top: -25px;
    z-index: 0;
  `)}
`

const IndicatorSolid = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  cursor: pointer;

  &[aria-checked='false'] {
    background-color: rgba(var(--appearance-inv-1-rgb), 0.25);
  }
  &[aria-checked='true'] {
    background-color: var(--text-12);
  }
`

const IndicatorSecondary = styled(IndicatorSolid)`
  &[aria-checked='false'] {
    background: transparent;
    box-shadow: inset 0px 0px 0px 1px rgba(var(--appearance-inv-1-rgb), 0.25);

    width: 6px;
    height: 6px;
  }
  &[aria-checked='true'] {
    background: var(--appearance-inv-1);
    box-shadow: inset 0px 0px 0px 1px transparent;

    width: 8px;
    height: 8px;
  }
`
